export default function widgetBehavior(publicAPI, model) {
  model.classHierarchy.push('vtkAxesLabelsWidgetProp')
}
